<template>
  <div class="about-page">
    <Header />
    
    <div class="page-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1>关于俊采</h1>
        <p>厚积薄发，登上峰顶，不是为了饱览风光，是为了寻找更高的山峰</p>
        <div class="scroll-indicator">
          <span>向下滚动了解更多</span>
          <i class="bi bi-chevron-down"></i>
        </div>
      </div>
    </div>
    
    <section class="about-content">
      <div class="container">
        <div class="company-intro">
          <div class="section-title">
            <span class="subtitle">企业简介</span>
            <h2>上海俊采</h2>
            <div class="divider"></div>
          </div>
          
          <div class="intro-cards">
            <div class="intro-card">
              <div class="icon">
                <i class="bi bi-building"></i>
              </div>
              <h3>专业服务</h3>
              <p>俊采猎头于2006年在上海成立，是一家专业的人力资源服务机构。"让每个人都得到发展，愿意与每个客户共同进步"的理念，吸引了来自Manpower、Randstad、Bestquarry等知名人力资源机构的众多专业人才。</p>
            </div>
            
            <div class="intro-card">
              <div class="icon">
                <i class="bi bi-globe"></i>
              </div>
              <h3>全国布局</h3>
              <p>2009年，俊采拿到第一笔风投，继而将业务拓展到新能源、机械、医药及医疗设备、家电等领域。目前，俊采除上海总部外，在广州、合肥、成都设有三家分公司，致力于为全中国的客户提供人力资源服务。</p>
            </div>
            
            <div class="intro-card">
              <div class="icon">
                <i class="bi bi-lightning-charge"></i>
              </div>
              <h3>行业优势</h3>
              <p>公司主要服务于物流、货代、IT、互联网、新能源、电力、电器等行业的客户，提供专业的人力资源服务。我们努力成为客户人力资源管理领域最好的合作伙伴。</p>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="left-content">
            <div class="section-title">
              <h2>发展历程</h2>
              <div class="divider"></div>
            </div>
            
            <div class="milestones">
              <div class="milestone-item">
                <div class="year">2006</div>
                <div class="event">成功注册"JC-Talent俊采"商标，树立品牌。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">2008</div>
                <div class="event">世界金融危机爆发，俊采业务流失超60%，遭遇生存危机。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">2009</div>
                <div class="event">俊采提出了猎头行业细分的概念，首家提出"精益猎头"概念的公司，并于同年付诸实施。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">2012</div>
                <div class="event">公司正式更名为俊采，确立了品牌发展战略。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">2015</div>
                <div class="event">在广州、合肥、成都设立分公司，业务覆盖全国。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">2020</div>
                <div class="event">获得"年度最具创造力企业"荣誉称号。</div>
              </div>
              
              <div class="milestone-item">
                <div class="year">至今</div>
                <div class="event">平均年龄35岁的团队，从物质到精神，从中国到世界，我们必须做些什么，从而留下存在于世的痕迹。</div>
              </div>
            </div>
          </div>
          
          <div class="right-content">
            <div class="about-image">
              <img src="@/assets/wallpaper7.jpg" alt="俊采猎头团队" />
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="philosophy">
      <div class="container">
        <div class="section-title">
          <h2>我们的思想</h2>
          <div class="divider"></div>
        </div>
        
        <div class="philosophy-content">
          <div class="quote">
            <h3>厚积薄发</h3>
            <p>登上峰顶，不是为了饱览风光，是为了寻找更高的山峰</p>
            <p>日出东方，告别了昨天的荣耀，将光芒照向更远的地方</p>
            <p>一路上，我们更在意如何积累和沉淀</p>
            <div class="quote-author">下一秒，让你看，我们到底有多强</div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="team">
      <div class="container">
        <div class="section-title">
          <h2>我们的团队</h2>
          <div class="divider"></div>
          <p>专业的人做专业的事</p>
        </div>
        
        <div class="team-intro">
          <p>俊采猎头拥有一支富有激情和专业素养的团队，平均年龄35岁，充满活力与创新精神。我们的顾问团队来自各大知名人力资源机构，拥有丰富的行业经验和专业知识，能够深入理解客户需求，提供高质量的猎头服务。</p>
          
          <p>我们的团队分为不同的行业专业组，包括物流供应链、互联网技术、新能源电力等，每个团队成员都对各自负责的领域有深入研究，保持对行业人才动态的敏锐洞察力。</p>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'AboutPage',
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped>
.about-page {
  overflow-x: hidden;
}

.page-banner {
  height: 500px;
  background-image: url('@/assets/wallpaper7.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.banner-content {
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-content h1 {
  font-size: 42px;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-weight: 700;
}

.banner-content p {
  font-size: 20px;
  margin-bottom: 30px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  animation: bounce 2s infinite;
  text-align: center;
}

.scroll-indicator span {
  font-size: 14px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.scroll-indicator i {
  font-size: 20px;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
}

.section-title .subtitle {
  display: inline-block;
  color: #009688;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  position: relative;
}

.section-title .subtitle:before, .section-title .subtitle:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: #009688;
}

.section-title .subtitle:before {
  left: -30px;
}

.section-title .subtitle:after {
  right: -30px;
}

.section-title h2 {
  font-size: 32px;
  margin-bottom: 15px;
  color: #1a2b2b;
  font-weight: 700;
}

.divider {
  width: 60px;
  height: 3px;
  background-color: #009688;
  margin: 0 auto 20px;
}

.about-content {
  padding: 100px 0;
  background-color: #fff;
}

.company-intro {
  margin-bottom: 80px;
}

.intro-cards {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 50px;
}

.intro-card {
  flex: 1;
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 16px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  transition: transform .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color .4s ease;
  text-align: center;
}

.intro-card:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.intro-card .icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  color: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 22px rgba(0, 150, 136, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.intro-card:hover .icon {
  transform: translateY(-4px) rotate(-6deg);
}

.intro-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #1a2b2b;
}

.intro-card p {
  font-size: 15px;
  line-height: 1.7;
  color: #6a7676;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.left-content {
  flex: 1 1 500px;
  padding: 0 15px;
  min-width: 0;
}

.left-content .section-title {
  text-align: left;
}

.left-content .divider {
  margin: 0 0 20px;
}

.milestones {
  margin-top: 40px;
  position: relative;
}

.milestones:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 15px;
  width: 2px;
  background-color: #eee;
  z-index: 0;
}

.milestone-item {
  display: flex;
  margin-bottom: 30px;
  position: relative;
}

.milestone-item .year {
  width: 35px;
  height: 35px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  margin-right: 20px;
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  box-shadow: 0 6px 14px rgba(0, 150, 136, 0.28);
}

.milestone-item .event {
  flex: 1;
  padding: 5px 15px;
  color: #6a7676;
  background-color: #f5f5f5;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.right-content {
  flex: 1;
  padding: 0 15px;
  min-width: 300px;
}

.about-image {
  margin-bottom: 30px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.about-image:hover {
  transform: scale(1.02);
}

.about-image img {
  width: 100%;
  height: auto;
  display: block;
}

.philosophy {
  padding: 80px 0;
  background-color: #f5f5f5;
}

.philosophy-content {
  display: flex;
  justify-content: center;
}

.quote {
  max-width: 800px;
  text-align: center;
  padding: 40px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  position: relative;
}

.quote::before {
  content: '\201C';
  font-size: 80px;
  color: #f0f0f0;
  position: absolute;
  top: 20px;
  left: 20px;
  font-family: serif;
}

.quote h3 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #1a2b2b;
}

.quote p {
  font-size: 16px;
  line-height: 1.8;
  color: #6a7676;
  margin-bottom: 15px;
}

.quote-author {
  font-style: italic;
  color: #999;
  margin-top: 20px;
}

.team {
  padding: 80px 0;
  background-color: #fff;
}

.team-intro {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.team-intro p {
  font-size: 16px;
  line-height: 1.8;
  color: #6a7676;
  margin-bottom: 20px;
}

@media (max-width: 992px) {
  .intro-cards {
    flex-direction: column;
  }
  
  .left-content, .right-content {
    min-width: 100%;
  }
  
  .right-content {
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .page-banner {
    height: 400px;
  }
  
  .banner-content h1 {
    font-size: 32px;
  }
  
  .banner-content p {
    font-size: 18px;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .about-content {
    padding: 80px 0;
  }
  
  .intro-card {
    padding: 20px;
  }
  
  .intro-card .icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .milestone-item .year {
    width: 25px;
    height: 25px;
    font-size: 12px;
  }
  
  .milestones:before {
    left: 12px;
  }
}

@media (max-width: 576px) {
  .page-banner {
    height: 300px;
    margin-top: 60px;
  }
  
  .banner-content h1 {
    font-size: 28px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
  
  .about-content {
    padding: 60px 0;
  }
  
  .company-intro {
    margin-bottom: 60px;
  }
}
</style> 